export default {"src":"/_next/static/media/chevron-down.fe8df474.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};